import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=011bf59a&scoped=true&"
import script from "./permissions.vue?vue&type=script&lang=ts&"
export * from "./permissions.vue?vue&type=script&lang=ts&"
import style0 from "./permissions.vue?vue&type=style&index=0&id=011bf59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011bf59a",
  null
  
)

export default component.exports